import { render } from "./CreatorDeliverableCreativeAssetComments.vue?vue&type=template&id=f5ed9826"
import script from "./CreatorDeliverableCreativeAssetComments.vue?vue&type=script&lang=js"
export * from "./CreatorDeliverableCreativeAssetComments.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/laravel/sundae-scoops/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__